//
//
//
//

import NotificationErrorIcon from '~/assets/images/icons/notification-error.svg?raw';
import NotificationSuccessIcon from '~/assets/images/icons/notification-success.svg?raw';
import NotificationInfoIcon from '~/assets/images/icons/notification-info.svg?raw';

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
    },
    computed: {
        /** @return {string} */
        iconSvg() {
            switch (this.type) {
                case 'error':
                    return NotificationErrorIcon;
                case 'info':
                    return NotificationInfoIcon;
                case 'success':
                    return NotificationSuccessIcon;
            }

            return '';
        },
    },
};
